import { fetch } from '@/shared/fetch';

export const deleteNnWeightLog = async (id: number) => {
    return await fetch<string>(`/api/nnsundvaegt/log/${id}`, 'DELETE');
};
